import apiService from "service/api";

export const getDashboard = async (hfId: number) => {
  console.log(hfId);
  return apiService(
    `/healthfacilities/${hfId}/dashboard/`,
    "GET",
    undefined,
    true
  );
};
